import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { SearchFilterModule } from '../project/searchFilter/search-filter.module';
import { DataNavbarComponent } from './data-navbar.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
    SearchFilterModule
  ],
  declarations: [DataNavbarComponent],
  providers: [],
  exports: [DataNavbarComponent]
})

export class DataNavbarModule {

}
